import TipoCalculos from "./Calculos";
import TipoRepeticoes from "./Repeticoes";
import { WrapperAlgoritmos } from "./styles";
import TipoCondicionais from "./Condicionais";
import { TipoAlgoritmoEnum } from "../../../../../enums/tipo-algoritmo.enum";

type Props = {
  expressao: string[];
  tipo: number;
};

export default function Algoritmos({ expressao, tipo }: Props) {
  function gerarAlgoritmo() {
    switch (tipo) {
      case TipoAlgoritmoEnum.CALCULOS:
        return TipoCalculos({ expressao });
      case TipoAlgoritmoEnum.CONDICIONAIS:
        return TipoCondicionais({ expressao });
      case TipoAlgoritmoEnum.REPETICOES:
        return TipoRepeticoes({ expressao });
    }
  }
  return <WrapperAlgoritmos>{gerarAlgoritmo()}</WrapperAlgoritmos>;
}
